import { useField, useForm } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { forwardRef } from 'react'
import { Input, InputProps } from './Input'

export type InputFieldProps = Omit<InputProps, 'value' | 'onChange'> & {
  name: string
  hideErrorMessage?: boolean
  validate?: FieldValidator<string>
  onChange?: (value: string) => void
}

export const InputField = forwardRef(
  ({ name, hideErrorMessage, validate, onChange, ...props }: InputFieldProps, ref) => {
    const form = useForm()
    const { input, meta } = useField<string>(name, { validate })

    const errorMessage = meta.error || meta.submitError || props.error

    return (
      <Input
        ref={ref}
        {...input}
        onChange={(value) => {
          onChange?.(value)
          return form.change(name, value)
        }}
        error={Boolean(meta.touched && errorMessage)}
        formHelperText={hideErrorMessage ? undefined : (meta.touched && errorMessage) || undefined}
        {...props}
      />
    )
  }
)

InputField.displayName = 'InputField'
